export const detailTypes = Object.freeze({
  VIDEO: 'video',
  IMAGE: 'image'
})
